/* BabyOrca - enlaces de packs (home) + hero CTA único + calculadora corregida + captura de email (Klaviyo) */
(function(){
  var MAP = {
    'Empezar con Esencial':'/products/pack-nacimiento-1-bebe',
    'Quiero el Pack Plus':'/products/pack-nacimiento-plus-1-bebe',
    'Quiero el Pack Premium':'/products/pack-nacimiento-premium-1-bebe',
    'Elegir Esencial PM':'/products/pack-parto-multiple-esencial',
    'Elegir Plus PM':'/products/pack-parto-multiple-plus',
    'Elegir Premium PM':'/products/pack-parto-multiple-premium',
    'Elegir Monoparental':'/products/pack-monoparental-1-bebe',
    'Elegir Mono Gemelos':'/products/pack-monoparental-gemelos'
  };
  var KLAVIYO='XL8hqf', LIST='XC4gNb';

  function validEmail(e){ return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e); }
  function subscribe(email){
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO, {
      method:'POST',
      headers:{'content-type':'application/json','revision':'2024-10-15'},
      body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Web BabyOrca',profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:LIST}}}}})
    });
  }
  function fmt(n){ return n.toLocaleString('es-ES')+' €'; }

  window.calcular = function(){
    var s=document.getElementById('calc-salario'); var c=document.getElementById('calc-ccaa'); var f=document.getElementById('calc-familia');
    var sal=parseFloat(s&&s.value)||0; var ccaa=c?c.value:''; var fam=f?f.value:'';
    if(!sal){ alert('Introduce tu salario bruto anual para estimar.'); return; }
    var base=sal/365;
    var sem1=(fam==='mono')?32:19;
    var sem2=(fam==='mono')?0:19;
    var inss=Math.round(base*7*(sem1+sem2));
    var hijos=(fam==='multiple')?2:1;
    var aeat=1200*3*hijos;
    var ccaaMap={madrid:500,cataluna:700,euskadi:900,galicia:1200,asturias:1500,cyl:1000,valencia:400,otras:0};
    var ayuda=ccaaMap[ccaa]||0;
    var total=inss+aeat+ayuda;
    var set=function(id,v){ var el=document.getElementById(id); if(el) el.textContent=v; };
    set('res-inss',fmt(inss)); set('res-aeat',fmt(aeat)); set('res-ccaa',ayuda?fmt(ayuda):'según CCAA'); set('res-total',fmt(total));
    var r=document.getElementById('calc-result');
    if(r){ r.classList.add('visible'); ensureCapture(); setTimeout(function(){ r.scrollIntoView({behavior:'smooth',block:'nearest'}); },100); }
  };

  function ensureCapture(){
    var r=document.getElementById('calc-result');
    if(!r || document.getElementById('bo-cap')) return;
    var d=document.createElement('div'); d.id='bo-cap';
    d.style.cssText='margin-top:14px;padding-top:14px;border-top:1px solid rgba(255,255,255,.2);text-align:center';
    d.innerHTML='<div style="font-size:14px;color:#fff;margin-bottom:8px;font-weight:600">¿Te enviamos el desglose y el pack que te encaja?</div>'
      +'<div style="display:flex;gap:8px;max-width:380px;margin:0 auto;flex-wrap:wrap;justify-content:center">'
      +'<input id="bo-cap-email" type="email" placeholder="Tu correo electrónico" style="flex:1;min-width:180px;padding:11px 14px;border-radius:8px;border:1px solid rgba(255,255,255,.4);background:rgba(255,255,255,.12);color:#fff;font-size:14px">'
      +'<button id="bo-cap-btn" type="button" style="padding:11px 18px;border:none;border-radius:8px;background:#E8927C;color:#fff;font-weight:700;cursor:pointer">Envíamelo</button></div>'
      +'<div id="bo-cap-msg" style="font-size:12px;color:rgba(255,255,255,.85);margin-top:8px"></div>';
    r.appendChild(d);
    var btn=d.querySelector('#bo-cap-btn'), em=d.querySelector('#bo-cap-email'), msg=d.querySelector('#bo-cap-msg');
    btn.addEventListener('click', function(){
      var v=(em.value||'').trim();
      if(!validEmail(v)){ msg.textContent='Escribe un correo válido.'; return; }
      btn.disabled=true; msg.textContent='Enviando…';
      subscribe(v).then(function(res){ msg.textContent = res.ok ? '¡Hecho! Revisa tu correo para confirmar la suscripción.' : 'Te hemos apuntado, te escribiremos pronto.'; })
        .catch(function(){ msg.textContent='Te hemos apuntado, te escribiremos pronto.'; });
    });
  }

  function wirePopup(){
    document.querySelectorAll('.bo-home .exit-row').forEach(function(row){
      var inp=row.querySelector('input'); var b=row.querySelector('button');
      if(!inp||!b||b.dataset.boWired) return; b.dataset.boWired='1';
      b.addEventListener('click', function(e){
        e.preventDefault();
        var v=(inp.value||'').trim();
        if(!validEmail(v)){ inp.style.borderColor='#e57373'; return; }
        b.disabled=true; b.textContent='Enviando…';
        subscribe(v).then(function(){ b.textContent='¡Hecho! Revisa tu correo'; }).catch(function(){ b.textContent='¡Hecho!'; });
      });
    });
  }

  /* Punto 17: hero con CTA único (Ver packs primario, calculadora como enlace debajo) */
  function wireHero(){
    var hb=document.querySelector('.bo-home .hero .hero-btns');
    if(!hb || hb.dataset.boHero) return; hb.dataset.boHero='1';
    hb.style.flexDirection='column'; hb.style.alignItems='flex-start'; hb.style.gap='10px';
    var calc=hb.querySelector('a[href="#calculadora"]');
    if(calc){
      calc.classList.remove('btn-outline','btn-light','btn-primary');
      calc.style.cssText='display:inline-flex;align-items:center;gap:6px;color:#3D6B7D;font-weight:600;font-size:.98rem;text-decoration:none;border-bottom:1px solid rgba(61,107,125,.4);padding:2px 0;background:none;box-shadow:none';
      calc.innerHTML='<i class="ti ti-calculator"></i> o calcula gratis lo que puedes cobrar <i class="ti ti-arrow-right"></i>';
    }
  }

  function wirePacks(){
    var root = document.querySelector('.bo-home');
    if(!root) return;
    root.querySelectorAll('.pack-cta').forEach(function(b){
      if(b.tagName==='A') return;
      var t = (b.textContent||'').trim();
      var url = MAP[t];
      if(!url) return;
      var a = document.createElement('a');
      a.href = url; a.className = b.className; a.setAttribute('role','button');
      a.innerHTML = b.innerHTML; a.style.textAlign='center'; a.style.textDecoration='none';
      var disp = getComputedStyle(b).display; a.style.display = (disp==='inline')?'inline-block':disp;
      b.parentNode.replaceChild(a, b);
    });
    root.querySelectorAll('.packs-extras a').forEach(function(a){
      var t=(a.textContent||'').trim().toLowerCase();
      if(t.indexOf('servicios individuales')>-1){ a.setAttribute('href','/pages/servicios#servicios'); }
      else if(t.indexOf('ayudas')>-1){ a.setAttribute('href','/pages/servicios#servicios'); }
    });
  }

  function wireHeroSocial(){
    var badge=document.querySelector('.bo-home .hero .hero-badge');
    if(!badge || document.getElementById('bo-sp')) return;
    var sp=document.createElement('div'); sp.id='bo-sp'; sp.className='bo-sp-row';
    sp.innerHTML='<span class="bo-sp-stars">★★★★★</span><span class="bo-sp-rate">4,9 <small>· reseñas en Google</small></span><span class="bo-sp-sep">·</span><span class="bo-sp-fam">+800 familias acompañadas</span>';
    badge.insertAdjacentElement('afterend', sp);
    var micro=document.querySelector('.bo-home .hero .hero-micro');
    if(micro){
      var q=document.createElement('div'); q.className='bo-sp-quote';
      q.innerHTML='<i class="ti ti-quote"></i><p>«Se encargaron de todos los trámites y ayudas cuando nació mi bebé. Experiencia de 10.» <b>— Daniela H., reseña en Google</b></p>';
      micro.insertAdjacentElement('afterend', q);
    }
  }

  function wireWhatsApp(){
    var fab=document.querySelector('.wa-fab');
    if(!fab || fab.dataset.boWa) return; fab.dataset.boWa='1';
    var dot=document.createElement('span'); dot.className='wa-dot'; fab.appendChild(dot);
    var bub=document.createElement('div'); bub.className='wa-bubble';
    bub.innerHTML='<button class="wa-bubble-x" aria-label="Cerrar">×</button>👋 ¿Te ayudo con el papeleo del bebé?';
    document.body.appendChild(bub);
    bub.querySelector('.wa-bubble-x').addEventListener('click',function(e){e.stopPropagation();bub.remove();});
    bub.addEventListener('click',function(){ window.open(fab.getAttribute('href'),'_blank'); });
    setTimeout(function(){ bub.classList.add('show'); }, 5000);
  }

  function init(){ wirePacks(); wireHero(); wireHeroSocial(); wirePopup(); wireWhatsApp(); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
